import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Calculator, Link2 } from 'lucide-react';
import NomenclatureEstimateursDialog from '../../components/NomenclatureEstimateursDialog';

export default function NomenclatureDialogs({ ctx }) {
  const { nomenclatures, selectedIds, showEstimatorDialog, setShowEstimatorDialog, estimatorConfig, setEstimatorConfig, showNomenclatureEstimateursDialog, setShowNomenclatureEstimateursDialog, currentNomenclatureForEstimateurs, setCurrentNomenclatureForEstimateurs, fetchNomenclatures, handleBulkEstimatorUpdate } = ctx;
  return (
    <>
      {/* Dialog Configuration Simulateur */}
      <Dialog open={showEstimatorDialog} onOpenChange={setShowEstimatorDialog}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>
              <div className="flex items-center gap-2">
                <Calculator className="h-5 w-5 text-green-600" />
                Lier au Simulateur Garantie Solidaire RCDS-BATICO
              </div>
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <p className="text-sm text-gray-600">
              Configuration pour {selectedIds.size} nomenclature(s) sélectionnée(s)
            </p>

            <div className="flex items-center space-x-2 p-3 bg-blue-50 rounded-lg">
              <input
                id="estimator_enabled"
                type="checkbox"
                checked={estimatorConfig.enabled}
                onChange={(e) => setEstimatorConfig({ ...estimatorConfig, enabled: e.target.checked })}
                className="w-5 h-5 rounded border-gray-300 text-blue-600"
              />
              <Label htmlFor="estimator_enabled" className="cursor-pointer font-semibold">
                Activer dans l'estimateur solidaire
              </Label>
            </div>

            {estimatorConfig.enabled && (
              <>
                <div>
                  <Label>Coefficient multiplicateur (optionnel)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={estimatorConfig.coefficient}
                    onChange={(e) => setEstimatorConfig({ ...estimatorConfig, coefficient: e.target.value })}
                    placeholder="Ex: 1.2"
                  />
                  <p className="text-xs text-gray-500 mt-1">Coefficient appliqué au calcul</p>
                </div>

                <div>
                  <Label>CA Minimum (€) (optionnel)</Label>
                  <Input
                    type="number"
                    value={estimatorConfig.min_ca}
                    onChange={(e) => setEstimatorConfig({ ...estimatorConfig, min_ca: e.target.value })}
                    placeholder="Ex: 50000"
                  />
                </div>

                <div>
                  <Label>CA Maximum (€) (optionnel)</Label>
                  <Input
                    type="number"
                    value={estimatorConfig.max_ca}
                    onChange={(e) => setEstimatorConfig({ ...estimatorConfig, max_ca: e.target.value })}
                    placeholder="Ex: 500000"
                  />
                </div>
              </>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEstimatorDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleBulkEstimatorUpdate} className="bg-green-600 hover:bg-green-700">
              <Link2 className="h-4 w-4 mr-2" />
              Appliquer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      {/* Dialog Nomenclature Estimateurs */}
      <NomenclatureEstimateursDialog
        isOpen={showNomenclatureEstimateursDialog}
        onClose={() => {
          setShowNomenclatureEstimateursDialog(false);
          setCurrentNomenclatureForEstimateurs(null);
        }}
        nomenclature={currentNomenclatureForEstimateurs}
        nomenclatures={nomenclatures.filter(n => selectedIds.has(n.id))}
        onUpdate={() => {
          fetchNomenclatures();
        }}
      />
    </>
  );
}
